import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { getDataClient } from "@/lib/dataClient";

export default function Yoklama() {
  const [params] = useSearchParams();
  const code = (params.get("code") ?? "").trim();
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleJoin = async () => {
    setStatus("loading");
    setErrorMsg("");
    try {
      const dataClient = getDataClient();
      const { error } = await dataClient.rpc("student_self_attendance", { p_room_code: code });
      if (error) throw error;
      setStatus("success");
    } catch (err) {
      setStatus("error");
      setErrorMsg(err instanceof Error ? err.message : "Yoklama alınamadı.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 min-h-[60vh]">
      {status === "success" ? (
        <>
          <span className="w-16 h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
            <i className="ri-check-line text-3xl" aria-hidden="true"></i>
          </span>
          <h1 className="mt-5 text-2xl font-bold text-foreground-950">Yoklaman alındı</h1>
          <p className="mt-2 text-sm text-foreground-600 max-w-sm">
            Derse katılımın kaydedildi. Şimdi canlı derse geçebilirsin.
          </p>
          <Link
            to="/ogrenci/canli-dersler"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap px-5 py-2.5 rounded-md text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
          >
            Canlı Derslere Git
          </Link>
        </>
      ) : (
        <>
          <span className={`w-16 h-16 flex items-center justify-center rounded-full ${status === "error" ? "bg-red-50 text-red-600" : "bg-primary-100 text-primary-700"}`}>
            <i className={status === "error" ? "ri-error-warning-line text-3xl" : "ri-qr-code-line text-3xl"} aria-hidden="true"></i>
          </span>
          <h1 className="mt-5 text-2xl font-bold text-foreground-950">QR Yoklama</h1>
          <p className="mt-2 text-sm text-foreground-600 max-w-sm">
            {code
              ? "Aşağıdaki butona tıklayarak bu dersin yoklamasına katıl."
              : "Yoklama kodu bulunamadı. Lütfen öğretmenin gösterdiği QR kodu tekrar okut."}
          </p>

          {status === "error" && (
            <p className="mt-4 text-sm text-red-700 bg-red-50 rounded-md px-3 py-2 max-w-sm">{errorMsg}</p>
          )}

          {code && status !== "error" && (
            <button
              type="button"
              onClick={handleJoin}
              disabled={status === "loading"}
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap px-5 py-2.5 rounded-md text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 disabled:opacity-60 transition-colors"
            >
              {status === "loading" ? (
                <>
                  <i className="ri-loader-4-line animate-spin" aria-hidden="true"></i>
                  İşleniyor...
                </>
              ) : (
                <>
                  <i className="ri-check-line" aria-hidden="true"></i>
                  Yoklamaya Katıl
                </>
              )}
            </button>
          )}

          {status === "error" && (
            <button
              type="button"
              onClick={handleJoin}
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap px-5 py-2.5 rounded-md text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              <i className="ri-refresh-line" aria-hidden="true"></i>
              Tekrar Dene
            </button>
          )}
        </>
      )}
    </div>
  );
}